import React, {
  ChangeEvent,
  RefObject,
} from 'react';
import clsx from 'clsx';
import MuiTextarea from '@mui/material/TextareaAutosize';

type Props = {
  id?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  autoFocus?: boolean;
  minRows?: number;
  maxRows?: number;
  maxLength?: number;
  className?: string;
  textAreaClassName?: string;
  inputRef?: RefObject<HTMLTextAreaElement>;
};

export default function FormTextarea({
  id,
  value = '',
  onChange,
  onBlur,
  placeholder,
  disabled,
  error,
  autoFocus,
  minRows = 2,
  maxRows,
  maxLength,
  className,
  textAreaClassName,
  inputRef,
}: Props) {
  const textAreaClasses = clsx('populate-textarea', textAreaClassName);
  const controlClasses = clsx(
    'populate-field-shell items-start overflow-hidden w-full',
    { 'has-error': error },
    className,
  );

  return (
    <div className={controlClasses}>
      <MuiTextarea
        className={textAreaClasses}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
          onChange?.(e.target.value);
        }}
        autoFocus={autoFocus}
        minRows={minRows}
        maxRows={maxRows}
        tabIndex={-1}
        disabled={disabled}
        onBlur={onBlur}
        maxLength={maxLength}
        ref={inputRef as RefObject<HTMLTextAreaElement>}
      />
    </div>
  );
}
